import http from './http'
let url = 'boleta'

// Boleta
export function postBoletaEmail(payload){
    return http.post(url + '/enviarEmail/' + payload.chave, payload)
}
export function postBoletaEmailUnimedBelem(chave, sqParcela, payload){
    return http.post(url + '/UnimedBelem/enviarEmail/' + chave + '/' + sqParcela, payload)
}
export function getBoletaSMS(payload){
    return http.get(url + '/enviarSMS/' + payload.chave + '/' + payload.telefone )
}
export function getArquivoBoleta(chave) {
    return http.get(url + '/arquivoBoleta/' + chave)
}